import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { BaseComponent } from 'src/app/shared/base.component';
import { DialogEvent } from 'src/app/shared/utilities/types.utilities';

@Component({
    selector: 'file-upload-modal',
    templateUrl: './file-upload-modal.component.html',
    styleUrls: ['./file-upload-modal.component.scss'],
})
export class FileUploadModalComponent extends BaseComponent implements OnInit {
    /** Emitter for user action on the modal */
    @Output() public event = new EventEmitter<DialogEvent>();
    /** Files selected */
    public files = [];
    /** Is dropping */
    public isDropping: boolean;
    /** File size limit */
    public SIZE_LIMIT: number = 20 * 1024 * 1024; // 20MB
    /** Files with size > SIZE_LIMIT */
    public files_error: any[] = [];

    constructor(private dialogRef: MatDialogRef<FileUploadModalComponent>) {
        super();
    }

    public ngOnInit(): void {}

    /** Called when files are dropped */
    public onDrop(event): void {
        event.preventDefault();
        this.isDropping = false;
        this.files_error = [];
        Array.from(event.dataTransfer.files).forEach((file: any) => {
            if (file.size > this.SIZE_LIMIT) {
                this.files_error.push(file);
            } else {
                this.files.push(file);
            }
        });
    }

    /** Needed for creating drop zone */
    public onDragOver(event): void {
        this.isDropping = true;
        event.preventDefault();
        event.stopPropagation();
    }

    public onFileChange(event): void {
        this.files_error = [];
        Array.from(event.target.files).forEach((file: any) => {
            if (file.size > this.SIZE_LIMIT) {
                this.files_error.push(file);
            } else {
                this.files.push(file);
            }
        });
    }

    /** Post files */
    public finish(): void {
        this.event.emit({ reason: 'done', metadata: this.files });
        this.close();
    }

    /** Remove files */
    public remove(name: string): void {
        this.files = Array.from(this.files).filter((file: File) => file.name !== name);
    }

    public close() {
        this.dialogRef.close();
    }
}
